import { useMemo } from 'react';
import { useChainMenuSettingsApiQuery } from './useChainMenuSettingsApiQuery';

export const useIsUsingBuyingEventManagement = () => {
    const { data } = useChainMenuSettingsApiQuery();

    return useMemo(() => {
        return !!data?.find((item) => item.menu.toString() === 'BuyingEventManagement')?.visible;
    }, [data]);
};
